export default __webpack_public_path__ + "static/media/acuityB.4b4b4712.svg";